<div class="m-grid__item m-aside-right right-aside-nav-my-class" [hidden]="!visible">
    <h6>Available analysis</h6>
    <div class="m-separator m-separator--dashed m--space-10"></div>
    <div class="m-widget2">
        <ng-template ngFor let-content [ngForOf]="contents">
            <div class="m-widget2__item m-widget2__item--{{content.color}} my-{{content.color}}-bg">
                <div class="m-widget2__checkbox"> </div>
                <a routerLink="{{content.link}}" class="m-widget2__desc">
                    <span class="m-widget2__text">
                        <ng-template ngFor let-elem [ngForOf]="content.list">
                            <h6 title={{elem.tooltip}} data-container="body" data-toggle="m-tooltip" 
                                    attr.data-original-title="{{elem.tooltip}}" data-placement="left"
                                    style="font-size: 0.9rem;">
                                <span class="my-{{content.color}}-font">{{elem.text}}</span>
                            </h6>
                        </ng-template>
                    </span>
                </a>
            </div>
        </ng-template>
    </div>
</div>